export const SESSION_STORAGE_KEY = "dolfin_portal_session";
export const ACTIVE_CLIENT_KEY = "dolfin_portal_active_client";
